import Vue from 'vue'
import store from '../store/index'

Vue.filter('currency', function (value) {
  return `${store.getters['app/currency']}${value}`
})
